module.exports = __webpack_public_path__ + "img/managphone.7f07af46.png";